import fp from 'lodash/fp';
import { LOCATION_CHANGE } from 'react-router-redux';
import { combineActions, handleActions } from 'redux-actions';
import { actions } from './actions';

export const initialState = {
  businesses: [],
  afsLicences: [],
  invitations: [],
  teamMembers: [],
  queryTeamMembers: undefined,
  teamMemberTrainingPlans: [],
  inactiveUsers: [],
  inactiveUserCpdActivity: null,
  isFetchingInactiveCpdActivities: false,
  unassignedTeamMembers: [],
  subscription: {},
  industryRoles: [],
  industryRolesIsFetching: false,
  businessCpdCategorys: [],
  cpdCategorysIsFetching: false,
  invitationChecked: false,
  validInvitation: false,
  isFetching: false,
  isResendingInvitations: false,
  resendingSuccess: false,
  isUpdating: false,
  isUpdatingAfsl: false,
  loadingInvitations: false,
  isFetchingTeamMembers: false,
  error: null,
  afslError: null,
  userIndustries: [],
  cpdActivities: null,
  isFetchingCpdActivities: false,
  fetchCpdActivitiesUserID: null,
  isFetchingMemberCpdCategorys: false,
  memberCpdCategorys: null,
  isFetchingExternalCpdForReview: false,
  externalCpdError: null,
  isFetchingTeams: false,
  isFetchingTeamsWithStats: false,
  isFetchingTeamCpdCategorys: false,
  isFetchingPendingExternalCpd: false,
  teams: undefined,
  teamsWithStats: undefined,
  teamsWithProgress: undefined,
  externalCpdForReview: undefined,
  invitationLink: undefined,
  taskStack: [],
  verifyInvitationResult: undefined,
  setTrainingPlanSuccess: undefined,
}

export const reducerDefinition = {
  [actions.business.initTaskStack().type]: ({ taskStack, ...state }, action) => ({
    ...state,
    taskStack: action.payload.append ? taskStack.concat(action.payload.tasks) : action.payload.tasks
  }),
  [actions.business.updateTaskStack().type]: ({ taskStack, ...state }, action) => ({
    ...state,
    taskStack: fp.flow(
      fp.map(
        (task) => task.id === action.payload.taskId ? { ...task, status: action.payload.status, data: action.payload.data } : task
      )
    )(taskStack)
  }),
  [combineActions(actions.business.api.subscribePlan.request,
    actions.business.api.getBusinesses.request,
    actions.business.api.getSubscription.request,
    actions.business.api.cancelSubscription.request,
    actions.business.api.removeMember.request,
    actions.business.api.addBusinessAdmin.request,
    actions.business.api.removeBusinessAdmin.request,
    actions.business.api.addBusinessManager.request,
    actions.business.api.removeBusinessManager.request)]: (state, action) => ({
      ...state,
      isFetching: true
    }),
  [combineActions(actions.business.api.updateBusiness.request,
    actions.business.api.updateSubscription.request)]: (state, action) => ({
      ...state,
      isUpdating: true,
      error: null
    }),
  [actions.business.api.updateBusiness.success]: (state, action) => ({
    ...state,
    error: null,
    businesses: fp.map((business) =>
      business.id === action.payload.business.id ?
        action.payload.business :
        business
    )(state.businesses),
    isUpdating: false
  }),
  [combineActions(actions.business.api.updateBusiness.failed,
    actions.business.api.updateSubscription.failed)]: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    }),
  [combineActions(actions.business.api.addAfsLicence.request,
    actions.business.api.removeAfsLicence.request)]: (state, action) => ({
      ...state,
      isUpdatingAfsl: true, 
      afslError: null
    }),

  [combineActions(actions.business.api.addAfsLicence.failed,
    actions.business.api.removeAfsLicence.failed)]: (state, action) => ({
      ...state,
      afslError: action.payload.error,
      isUpdatingAfsl: false
    }),

  [combineActions(actions.business.api.getInvitations.request,
    actions.business.api.deleteInvitation.request,
    actions.business.api.sendInvitations.request)]: (state, action) => ({
      ...state,
      loadingInvitations: true
    }),
  [actions.business.api.getTeamCpdCategorys.request]: (state, action) => ({
    ...state,
    isFetchingTeamCpdCategorys: true
  }),
  [actions.business.api.getTeamPendingExternalCpd.request]: (state, action) => ({
    ...state,
    isFetchingPendingExternalCpd: true
  }),
  [actions.business.api.getSpecificTeamPendingExternalCpd.request]: (state, action) => ({
    ...state,
    isFetchingPendingExternalCpd: true
  }),
  [combineActions(actions.business.api.getTeamMembers.request,
    actions.business.api.getUnassignedTeamMembers.request,
    actions.business.api.removeMember.request,
    actions.business.api.addBusinessAdmin.request,
    actions.business.api.removeBusinessAdmin.request,
    actions.business.api.addBusinessManager.request,
    actions.business.api.removeBusinessManager.request)]: (state, action) => ({
      ...state,
      isFetchingTeamMembers: true
    }),
  [combineActions(actions.business.api.queryTeamMembers.request,
    actions.business.api.loadMoreTeamMembers.request)]: (state, action) => ({
      ...state,
      isFetchingTeamMembers: true
    }),
      [actions.business.api.addAfsLicence.success]: (state, action) => ({
    ...state,
    // Currently we only allow ONE AFSL to be associated to a business.
    // But it is built with potentially have multiple AFSLs.
    // Update this if we start allowing multile AFSL associations.
    afsLicences: [action.payload.afsLicence],
    isUpdatingAfsl: false,
    afslError: null
  }),
  [actions.business.api.removeAfsLicence.success]: (state, action) => ({
    ...state,
    afsLicences: [],
    isUpdatingAfsl: false,
    afslError: null
  }),
  [combineActions(actions.business.api.removeMember.failed,
    actions.business.api.addBusinessAdmin.failed,
    actions.business.api.removeBusinessAdmin.failed,
    actions.business.api.addBusinessManager.failed,
    actions.business.api.removeBusinessManager.failed)]: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetchingTeamMembers: false,
      isFetching: false
    }),
  [actions.business.api.subscribePlan.failed]: (state, action) => ({
    ...state,
    error: action.payload.error,
    isFetching: false
  }),
  [combineActions(actions.business.api.subscribePlan.success,
    actions.business.api.getSubscription.success,
    actions.business.api.updateSubscription.success,
    actions.business.api.updatePaymentDetails.success)]: (state, action) => ({
      ...state,
      error: null,
      subscription: action.payload.subscription,
      isFetching: false,
      isUpdating: false
    }),
  [actions.business.api.updatePaymentDetails.failed]: (state, action) => ({
    ...state,
    error: action.payload.error,
    isFetching: false,
    isUpdating: false
  }),
  [combineActions(actions.business.api.cancelSubscription.success,
    actions.business.api.getSubscription.failed)]: (state, action) => ({
      ...state,
      error: null,
      subscription: action.payload.subscription,
      isFetching: false
    }),
  [actions.business.api.verifyInvitation.request]: (state, action) => ({
    ...state,
    invitationChecked: false,
    validInvitation: false,
    isFetching: true
  }),
  [actions.business.api.verifyInvitation.success]: (state, action) => ({
    ...state,
    invitationChecked: true,
    validInvitation: true,
    verifyInvitationResult: action.payload.invitation,
    isFetching: false
  }),
  [actions.business.api.verifyInvitation.failed]: (state, action) => ({
    ...state,
    invitationChecked: true,
    validInvitation: false,
    isFetching: false
  }),
  [actions.business.api.cancelSubscription.failed]: (state, action) => ({
    ...state,
    error: action.payload.error,
    isFetching: false
  }),
  [actions.business.api.getBusinesses.success]: (state, action) => ({
    ...state,
    businesses: action.payload.businesses,
    isFetching: false
  }),
  [actions.business.api.getInactiveUsers.success]: (state, action) => ({
    ...state,
    inactiveUsers: action.payload.inactiveUsers
  }),
  [actions.business.api.getInactiveUserCpdActivity.success]: (state, action) => ({
    ...state,
    inactiveUserCpdActivity: action.payload.cpdActivity,
    isFetchingInactiveCpdActivities: false
  }),
  [actions.business.api.getInactiveUserCpdActivity.request]: (state, action) => ({
    ...state,
    inactiveUserCpdActivity: null,
    isFetchingInactiveCpdActivities: true
  }),
  [actions.business.api.getInactiveUserCpdActivity.failed]: (state, action) => ({
    ...state,
    isFetchingInactiveCpdActivities: false
  }),
  [actions.business.api.getAfsLicences.success]: (state, action) => ({
    ...state,
    afsLicences: action.payload.afsLicences,
    isFetching: false
  }),
  [actions.business.api.resendInvitation.request]: (state, action) => ({
    ...state,
    isResendingInvitations: true
  }),
  [actions.business.api.resendInvitation.success]: (state, action) => ({
    ...state,
    invitations: action.payload.invitations,
    isResendingInvitations: false,
    resendingSuccess: true
  }),
  [actions.business.api.resendInvitation.failed]: (state, action) => ({
    ...state,
    isResendingInvitations: false,
    resendingSuccess: false
  }),
  [combineActions(actions.business.api.getInvitations.success,
    actions.business.api.deleteInvitation.success,
    actions.business.api.sendInvitations.success)]: (state, action) => ({
      ...state,
      invitations: action.payload.invitations,
      loadingInvitations: false
    }),
  [combineActions(actions.business.api.getInvitations.failed,
    actions.business.api.deleteInvitation.failed,
    actions.business.api.sendInvitations.failed)]: (state, action) => ({
      ...state,
      loadingInvitations: false
    }),
  [combineActions(actions.business.api.getTeamMembers.success,
    actions.business.api.removeMember.success,
    actions.business.api.addBusinessAdmin.success,
    actions.business.api.removeBusinessAdmin.success,
    actions.business.api.addBusinessManager.success,
    actions.business.api.removeBusinessManager.success)]: (state, action) => ({
      ...state,
      teamMembers: action.payload.teamMembers,
      isFetchingTeamMembers: false,
      isFetching: false
    }),
  [actions.business.api.queryTeamMembers.success]: (state, action) => ({
    ...state,
    queryTeamMembers: action.payload.teamMembers,
    isFetchingTeamMembers: false,
    isFetching: false
  }),
  [actions.business.api.loadMoreTeamMembers.success]: (state, action) => ({
    ...state,
    queryTeamMembers: {
      ...action.payload.teamMembers,
      teamMembers: state.queryTeamMembers.teamMembers.concat(action.payload.teamMembers.teamMembers)
    },
    isFetchingTeamMembers: false,
    isFetching: false
  }),
  [actions.business.api.queryTeamMemberTrainingPlans.success]: (state, action) => ({
    ...state,
    teamMemberTrainingPlans: action.payload.teamMemberTrainingPlans
  }),
  [actions.business.api.getUnassignedTeamMembers.success]: (state, action) => ({
    ...state,
    unassignedTeamMembers: action.payload.teamMembers,
    isFetchingTeamMembers: false,
    isFetching: false
  }),
  [actions.business.api.getTeamCpdCategorys.success]: (state, action) => ({
    ...state,
    teamCpdCategorys: action.payload.teamCpdCategorys,
    isFetchingTeamCpdCategorys: false
  }),
  [actions.business.api.getTeamCpdCategorys.failed]: (state, action) => ({
    ...state,
    isFetchingTeamCpdCategorys: false
  }),
  [actions.business.api.getTeamPendingExternalCpd.success]: (state, action) => ({
    ...state,
    teamPendingExternalCpd: action.payload.teamPendingExternalCpd,
    isFetchingPendingExternalCpd: false,
  }),
  [actions.business.api.getTeamPendingExternalCpd.failed]: (state, action) => ({
    ...state,
    isFetchingPendingExternalCpd: false
  }),
  [actions.business.api.getSpecificTeamPendingExternalCpd.success]: (state, action) => ({
    ...state,
    specificTeamPendingExternalCpd: action.payload.teamPendingExternalCpd,
    isFetchingPendingExternalCpd: false,
  }),
  [actions.business.api.getSpecificTeamPendingExternalCpd.failed]: (state, action) => ({
    ...state,
    isFetchingPendingExternalCpd: false
  }),
  [actions.business.api.getIndustryRoles.request]: (state, action) => ({
    ...state,
    industryRoles: initialState.industryRoles,
    industryRolesIsFetching: true
  }),
  [actions.business.api.getIndustryRoles.success]: (state, action) => ({
    ...state,
    error: null,
    industryRoles: action.payload.industryRoles,
    industryRolesIsFetching: false
  }),
  [actions.business.api.getIndustryRoles.failed]: (state, action) => ({
    ...state,
    error: action.payload.error,
    industryRolesIsFetching: false
  }),
  [actions.business.api.updateIndustryRole.success]: (state, { payload: { industryRole } }) => ({
    ...state,
    industryRoles: fp.concat(
      fp.filter(x => x.id !== industryRole.id)(state.industryRoles),
      industryRole
    )
  }),
  [actions.business.api.profile.request]: (state, action) => ({
    ...state,
    isFetchingProfile: true
  }),
  [actions.business.api.profile.success]: (state, action) => ({
    ...state,
    profile: action.payload.profile,
    isFetchingProfile: false
  }),
  [actions.business.api.profile.failed]: (state, action) => ({
    ...state,
    isFetchingProfile: false
  }),
  [actions.business.api.getCpdCategorys.request]: (state, action) => ({
    ...state,
    businessCpdCategorys: initialState.businessCpdCategorys,
    cpdCategorysIsFetching: true
  }),
  [actions.business.api.getCpdCategorys.success]: (state, action) => ({
    ...state,
    businessCpdCategorys: action.payload.businessCpdCategorys,
    cpdCategorysIsFetching: false
  }),
  [actions.business.api.getCpdCategorys.failed]: (state, action) => ({
    ...state,
    error: action.payload.error,
    cpdCategorysIsFetching: false
  }),
  [actions.business.api.setCpdCategorys.request]: (state, action) => ({
    ...state,
    setTrainingPlanSuccess: undefined,
    isUpdating: true
  }),
  [actions.business.api.setCpdCategorys.success]: (state, action) => ({
    ...state,
    businessCpdCategorys: action.payload.businessCpdCategorys,
    setTrainingPlanSuccess: { success: true, info: 'Training Plan Updated' },
    isUpdating: false
  }),
  [actions.business.api.setCpdCategorys.failed]: (state, action) => ({
    ...state,
    setTrainingPlanSuccess: { success: false, info: 'Training Plan Update Failed' },
    error: action.payload.error,
    isUpdating: false
  }),
  [actions.business.setApplyToAllSuccess().type]: (state, action) => ({
    ...state,
    setTrainingPlanSuccess: { success: true, info: 'Training plan applied to all users' },
  }),
  [actions.business.api.getInvitationLink.success]: (state, action) => ({
    ...state,
    invitationLink: action.payload.invitationLink
  }),
  [actions.business.api.getBusinessActivities.request]: (state, action) => ({
    ...state,
    isFetchingBusinessActivities: true,
  }),
  [actions.business.api.getBusinessActivities.success]: (state, action) => ({
    ...state,
    isFetchingBusinessActivities: false,
    businessActivities: state.businessActivities ? {
      ...action.payload.businessActivities,
      result: state.businessActivities.result.concat(action.payload.businessActivities.result)
    } : action.payload.businessActivities,
  }),
  [actions.business.api.getBusinessActivities.failed]: (state, action) => ({
    ...state,
    isFetchingBusinessActivities: false
  }),
  [actions.business.cleanBusinessActivities().type]: (state, action) => ({
    ...state,
    businessActivities: undefined
  }),
  [LOCATION_CHANGE]: (state, action) => ({
    ...state,
    error: null,
    afslError: null,
    isFetching: false,
    setTrainingPlanSuccess: undefined,
    externalCpd: undefined,
    isFetchingInactiveCpdActivities: false,
    team: {
      currentTeam: undefined,
      error: undefined
    },
    queryTeamMembers: undefined,
    teams: undefined,
    externalCpdForReview: undefined,
    memberCpdCategorys: undefined,
    cpdActivities: undefined,
    invitationLink: undefined,
    user: {
      ...state.user,
      setBusinessUserTrainingPlanSuccess: undefined
    }
  })
}

export default handleActions(reducerDefinition, { ...initialState });


// WEBPACK FOOTER //
// ./src/state/modules/business/business/reducers.js